export const BANK_STATEMENTS = "BANK_STATEMENTS";
export const ZAPIER = "ZAPIER";
export const GOOGLE_DRIVE = "GOOGLE_DRIVE";
export const ONEDRIVE = "ONEDRIVE";
